module.exports = __webpack_public_path__ + "media/images/layout/foot_icons_btn-c638b086a60e17f8c2b59ad9c8add21e.svg";